import { BASE_URL, FeedSortType, isFeedSortTypeValid } from '@ai-platform/utils';

import { getActiveCategories } from '../../data/categories';
import { RoutePaths, SEARCH_PARAMS } from '../../constants';

const CATEGORY_REGEX = new RegExp(`${BASE_URL}${RoutePaths.Category}/([^/?#]+)`);
export function getUserProfileLink(publicId: string) {
    return `${RoutePaths.UserProfile}/${publicId}`;
}

const validCategoryIds = new Set(getActiveCategories().map(category => category.id));

const isCategoryValid = (category: string | null): boolean => {
    if (!category) {
        return false;
    }

    return validCategoryIds.has(category);
};

export const parseCategoryFromUrl = (pathCategory?: string | null): string | null => {
    if (pathCategory && validCategoryIds.has(pathCategory)) {
        return pathCategory;
    }

    return null;
};

/**
 * Формирует URL путь из категории
 * Схема: null → '/', 'family' → '/c/family'
 */
export const buildCategoryPath = (category: string | null): string => {
    const isValid = isCategoryValid(category);

    if (!isValid) {
        return RoutePaths.Main;
    }

    return [RoutePaths.Category, category].join('/');
};

export function getCategoryFromLocationPath(locationPath: string): string | null {
    const category = locationPath.match(CATEGORY_REGEX)?.[1] ?? null;

    return parseCategoryFromUrl(category);
}

export function getFeedSortFromSearchParams(params: URLSearchParams): FeedSortType | null {
    const feedSortType = params.get(SEARCH_PARAMS.SORT);
    const isFeedSortValid = isFeedSortTypeValid(feedSortType);

    return isFeedSortValid ? feedSortType : null;
}

export function isExternalURL(link: string): boolean {
    return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(link);
}
